import { useQuery } from '@tanstack/react-query';
import { fetchAllNomenclatures } from '../NomenclaturesPage/services';

export const useAllNomenclatures = () => {
  const { data: nomenclatures } = useQuery({
    queryKey: ['nomenclatures', 'all'],
    queryFn: () => fetchAllNomenclatures(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return { nomenclatures };
};
